import React from "react";
import { List, Avatar, Typography, Badge } from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

const ChatList = ({ chats, activeChat, setActiveChat }) => {
  return (
    <List
      itemLayout="horizontal"
      dataSource={chats
        .filter((chat) => chat.lastMessage)
        .sort((a, b) =>
          dayjs(b.lastMessageAt).isBefore(dayjs(a.lastMessageAt)) ? -1 : 1,
        )}
      renderItem={(chat) => {
        const lastMessageAt = chat.lastMessageAt
          ? dayjs(chat.lastMessageAt)
          : null;

        const formattedTime = lastMessageAt
          ? lastMessageAt.isSame(dayjs(), "day")
            ? lastMessageAt.format("HH:mm")
            : lastMessageAt.format("DD/MM/YY")
          : "";

        const isActive = activeChat?._id === chat._id;

        return (
          <List.Item
            style={{
              padding: "12px 16px",
              cursor: "pointer",
              backgroundColor: isActive ? "#e6f4ff" : "transparent",
              borderBottom: "1px solid #f5f5f5",
              transition: "background-color 0.2s ease",
            }}
            onClick={() => setActiveChat(chat)}
          >
            <List.Item.Meta
              avatar={
                <Avatar
                  src={chat.otherParticipant.photoUrl || "/default-avatar.png"}
                  size={44}
                />
              }
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "2px",
                  }}
                >
                  <Text
                    strong
                    ellipsis
                    style={{
                      maxWidth: "140px",
                      fontSize: "14px",
                      color: isActive ? "#1677ff" : "#262626",
                    }}
                  >
                    {chat.otherParticipant.username}
                  </Text>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <Text type="secondary" style={{ fontSize: "11px" }}>
                      {formattedTime}
                    </Text>
                    {!chat.lastMessageRead && (
                      <Badge
                        count={chat.unreadMessagesCount}
                        overflowCount={99}
                        color="#1677ff"
                      />
                    )}
                  </div>
                </div>
              }
              description={
                <Text
                  type="secondary"
                  ellipsis
                  style={{
                    fontSize: "12px",
                    display: "block",
                    maxWidth: "200px",
                  }}
                >
                  {chat.lastMessage}
                </Text>
              }
            />
          </List.Item>
        );
      }}
    />
  );
};

export default ChatList;
